import {updateLabelConfig} from '../../../data/labelInfos/index.js'
import ConfigSelect from './ConfigSelect.js'
import {DHL_ECOMMERCE} from '../../../common/constants/ShipperNames.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {
  ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
  defaultValidLabelPropertiesFunc,
} from './useLabelProperty.js'

const VALID_SHIPPER_TYPES = [DHL_ECOMMERCE]

function labelPropertiesFunc(shipperType) {
  return VALID_SHIPPER_TYPES.includes(shipperType)
    ? [`${shipperType}__service_endorsement`]
    : []
}

export default function ServiceEndorsement() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = ServiceEndorsement.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )

  return (
    <ConfigSelect
      label="Service Endorsement"
      onChange={(value) => {
        updateLabelConfig(labelInfoID, {
          [labelProperty]: value,
        })

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      shipperOptionsProperty="service_endorsement"
    />
  )
}

ServiceEndorsement.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc: labelPropertiesFunc,
    dependentPropertiesFunc: ADDITIONAL_SHIPPER_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
  },
]
